module.exports = __webpack_public_path__ + "img/floor_b1_02.2aebc159.png";